import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import green from "@material-ui/core/colors/green";
import { withStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";

import Filter from "../../components/elements/Filter";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import TableList from "../../components/elements/TableList";
import { getLangAll, getLingoPlans } from "../../store/middleware";
import Placeholder from "../../components/Placeholder/PlaceholderByPage";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import Engrenagem from "../../assets/images/icons/icon_planspricing_header.svg";

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: 0,
    marginLeft: -15,
  },
});

function PlansAndPrices() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { lingoPlans } = useSelector((state) => state.genericReducer);

  const [filter, setFilter] = useState({
    planName: "",
    lingoLanguageId: "",
    bestSeller: "",
    active: "",
  });

  const resetFilter = () => {
    setFilter({
      planName: "",
      lingoLanguageId: "",
      bestSeller: "",
      active: "",
    });
    callApi();
  };

  const applyFilters = () => {
    let criteria = {
      lingoLanguageId: filter.lingoLanguageId === "" ? null : filter.lingoLanguageId,
      planName: filter.planName === "" ? null : filter.planName,
      bestSeller: filter.bestSeller === "" ? null : filter.bestSeller === "True" ? true : false,
      active: filter.active === "" ? null : filter.active === "0" ? false : true,
    };

    dispatch(getLingoPlans(criteria));
  };

  const inputChange = (e, name) => {
    e.preventDefault();
    const { value } = e.target;

    setFilter((state) => ({ ...state, [name]: value }));
  };

  const callApi = async () => {
    await dispatch(initLoading());
    let criteria = {
      skip: 0,
      take: 1000,
      languageId: "",
      active: null,
      planName: "",
      bestSeller: null,
    };

    await dispatch(getLingoPlans(criteria));
    await dispatch(getLangAll());
    await dispatch(endLoading());
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line
  }, []);

  const statusOptions = ["Inactive", "Active"].map((option, index) => {
    return { id: index, name: option };
  });

  const bestSellerOptions = ["Yes", "No"].map((option, index) => {
    return { id: index, name: option };
  });

  const filters = [
    { name: "planName", value: filter.planName, label: "Plan Name", placeholder: "Plan Name", type: "text" },
    {
      type: "lingoLanguages",
      placeholder: "Select",
      name: "lingoLanguageId",
      label: "Native Language",
      value: filter.lingoLanguageId,
    },
    {
      name: "bestSeller",
      value: filter.bestSeller,
      label: "Best Seller",
      placeholder: "Select",
      options: bestSellerOptions,
      type: "select",
    },
    {
      name: "active",
      value: filter.active,
      label: "Status",
      placeholder: "Select",
      options: statusOptions,
      type: "select",
    },
  ];

  const listItems = [
    { label: "Name", name: "name" },
    { label: "Lingos", name: "lingo" },
    { label: "Number of classes", name: "totalClasses" },
    { label: "Status", name: "status" },
    { label: "", name: "button" },
  ];

  const renderLingos = (lingo) => {
    let arrayLingos = lingo?.split(",");
    let newArr = [];

    if (arrayLingos?.length > 0) {
      arrayLingos.map((item) => newArr.push(item.trim()));
    }
    return newArr;
  };

  const listedPlans = lingoPlans?.map((item) => {
    return {
      id: item.id,
      name: item.nameEnglish,
      lingo: renderLingos(item.flag),
      totalClasses: item.totalClasses === 0 ? "Unlimited" : item.totalClasses,
      status: item.active ? "Active" : "Inactive",
      multiLingo: item.multiLingo,
    };
  });

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          title="Plans and Prices"
          typeIcon="custom"
          icon={<img src={Engrenagem} alt="Engrenagem" />}
          rightButton={
            <button className="buttonRight" onClick={() => navigate("/plans-and-prices/new")}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add new Plan
            </button>
          }
          t={t}
        />
        <div className="content">
          <Filter filters={filters} inputChange={inputChange} submit={applyFilters} clear={resetFilter} />

          {lingoPlans?.length > 0 ? (
            <TableList component="plans-and-prices" listItems={listItems} listedItems={listedPlans} />
          ) : (
            <Placeholder pageName="users" textMsg="No results" />
          )}
        </div>
      </section>
    </div>
  );
}

export default withStyles(styles)(PlansAndPrices);
